import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiUserPlus, FiShield, FiArrowRight } from 'react-icons/fi';
import { useTenant } from './Layout';

export default function NoTenantGuard({ children, pageName }) {
  const { selectedTenantId, tenants } = useTenant();
  const navigate = useNavigate();

  if (!selectedTenantId || tenants.length === 0) {
    return (
      <div>
        <div className="card" style={{
          textAlign: 'center',
          padding: '3rem 2rem',
          background: 'linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)',
          border: '2px solid #e0e7ff',
        }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%', margin: '0 auto 1.25rem',
            background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <FiShield style={{ fontSize: '2rem', color: '#fff' }} />
          </div>
          <h2 style={{ marginBottom: '0.75rem', color: '#1f2937', fontSize: '1.5rem' }}>
            {tenants.length === 0 ? 'Get Started' : 'Select a Tenant'}
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem', maxWidth: 480, margin: '0 auto 1.5rem', lineHeight: 1.6 }}>
            {tenants.length === 0
              ? 'Onboard your first cloud tenant to start analyzing your landing zone governance, compliance, and security posture.'
              : 'Select a tenant from the dropdown above to view analysis data for this page.'}
          </p>
          {tenants.length === 0 && (
            <button
              className="btn btn-primary"
              onClick={() => navigate('/onboarding')}
              style={{
                padding: '0.75rem 2rem', fontSize: '1rem', fontWeight: 600,
                display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                borderRadius: 10, boxShadow: '0 4px 14px rgba(79, 70, 229, 0.3)'
              }}
            >
              <FiUserPlus />
              Onboard Your First Tenant
              <FiArrowRight />
            </button>
          )}
        </div>

        <div style={{ marginTop: '1.5rem' }}>
          <h3 style={{ color: '#374151', marginBottom: '1rem', fontSize: '1.1rem' }}>What you can do once connected</h3>
          <div className="grid-3">
            {[
              { icon: '🔍', title: 'Drift Detection', desc: 'Monitor configuration drift against your baselines with compliance posture tracking.' },
              { icon: '🛡️', title: 'Governance Assessment', desc: 'Evaluate 8 governance pillars with 46 assessment items and maturity scoring.' },
              { icon: '📊', title: 'Risk Forecasting', desc: 'Predict future risks based on resource growth, complexity, and compliance trends.' },
            ].map((item, i) => (
              <div key={i} className="card" style={{ padding: '1.25rem', textAlign: 'center' }}>
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{item.icon}</div>
                <h4 style={{ fontSize: '0.95rem', marginBottom: '0.4rem', color: '#1f2937' }}>{item.title}</h4>
                <p style={{ fontSize: '0.8rem', color: '#6b7280', lineHeight: 1.5 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return children;
}
